import { donorRecipientConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const sendDonorEmailUpdate = ({ donorId, recipientId, donorRecipientLinkId, form }) => ({
    type: apiConstants.API,
    payload: {
        url: url.donorEmailUpdate.replace(':donorId', donorId).replace(':recipientId', recipientId).replace(':donorRecipientLinkId', donorRecipientLinkId),
        method: 'POST',
        body: form,
        request: () => ({ type: donorRecipientConstants.SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_REQUEST }),
        success: (data) => ({ type: donorRecipientConstants.SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_SUCCESS, data }),
        failure: (error) => ({ type: donorRecipientConstants.SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_FAILURE, error }),
        formatData: (data) => (donorRecipientLinkId),
        progress: {
            request: { message: () => 'Sending email update to donor.' },
            success: { message: () => 'Successfully sent email update to donor.' }
        },
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/donorEmailUpdate.actions.js